import { onColorSchemeChange } from '../app/colorScheme.js';

const THEME_STORAGE_KEY = 'fluveria-theme';

export type ThemeMode = 'system' | 'light' | 'dark';

function applyTheme(theme: ThemeMode): void {
  document.documentElement.dataset.theme = theme;
  window.dispatchEvent(new CustomEvent('app-theme-change', { detail: theme }));
}

function readStoredTheme(): ThemeMode {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  return stored === 'dark' || stored === 'light' || stored === 'system' ? stored : 'system';
}

export function initThemeControl(): void {
  const select = document.getElementById('theme-select') as HTMLSelectElement | null;
  if (!select) return;

  const initialTheme = readStoredTheme();
  select.value = initialTheme;
  applyTheme(initialTheme);

  select.addEventListener('change', event => {
    const nextTheme = (event.target as HTMLSelectElement).value as ThemeMode;
    localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
    applyTheme(nextTheme);
  });

  onColorSchemeChange(() => {
    if (readStoredTheme() === 'system') applyTheme('system');
  });
}
